import sanitizeHtml from 'sanitize-html';
import { useRef, useState } from 'react';

function sanitize(dirty) {
    return sanitizeHtml(dirty, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
            'img',
            'iframe',
        ]),
        allowedAttributes: {
            '*': ['style'],
            a: ['href'],
            img: ['src', 'alt', 'width', 'height'],
            iframe: ['src', 'width', 'height'],
        },
        allowedStyles: {
            '*': {
                // Match HEX and RGB
                'background-color': [
                    /^#(0x)?[0-9a-f]+$/i,
                    /^[a-z]+$/i,
                    /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                ],
                color: [
                    /^#(0x)?[0-9a-f]+$/i,
                    /^[a-z]+$/i,
                    /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                ],
                'border-radius': [/^\d+(?:px|em|%)$/],
                'text-align': [/^left$/, /^right$/, /^center$/],
                // Match any number with px, em, or %
                'font-size': [/^\d+(?:px|em|%)$/],
                margin: [/.*/],
                padding: [/.*/],
            },
            p: {
                'font-size': [/^\d+rem$/],
            },
        },
        allowedIframeHostnames: ['www.google.com'],
    });
}

const SafeHtml = ({ html, iframe }) => {
    const [iframeHeight, setIframeHeight] = useState();
    const iframeRef = useRef();
    const sanitized = sanitize(html);
    if (iframe) {
        const css = `<style type="text/css">html { font-family: ui-rounded, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; }</style>`;
        return (
            <iframe
                ref={iframeRef}
                srcDoc={css + sanitized}
                className="w-full h-fit scrollbar-visible min-h-64"
                style={{ height: `${iframeHeight}px` }}
                onLoad={() => {
                    setIframeHeight(iframeRef.current?.contentWindow?.document.body.scrollHeight + 32);
                }}
            />
        );
    } else {
        return (
            <div
                dangerouslySetInnerHTML={{ __html: sanitized }}
                className="whitespace-pre-wrap rendered-html"
            ></div>
        );
    }

};

export default SafeHtml;
